export enum ProfileSwitcherActionType {
  AddNew = 'AddNew'
}

export type ProfileSwitcherDataType = {id: string; name: string} | ProfileSwitcherActionType;
